import React, { useCallback, useMemo } from 'react';
import { Box } from '@televet/kibble-ui/build/chakra';
import { RatingDots } from '@televet/kibble-ui/build/components/RatingDots';
import { useSurveySettingsContext } from 'pages/Survey/context/SurveySettingsContext';
import WildcardTextInput, {
  WildcardInputQuestionTypes,
  WildcardInputPreviewModes,
} from 'pages/Forms/FormsContent/FormsDrafting/WildcardInputs/WildcardTextInput';
import { SurveyType } from 'shared/types/graphql';

interface IRatingStepProps {
  rating: number | undefined;
  setRating: React.Dispatch<React.SetStateAction<number | undefined>>;
}

const RatingStep = ({ rating, setRating }: IRatingStepProps): JSX.Element => {
  const { composeSettings, surveyType } = useSurveySettingsContext();

  const isNpsSurvey = useMemo(() => surveyType === SurveyType.Nps, [surveyType]);

  const selectRating = useCallback(
    (value: number) => {
      setRating(value);
    },
    [setRating],
  );

  return (
    <Box className="preview__form-step" id="survey-preview-step-rating">
      <WildcardTextInput
        text={composeSettings.ratingQuestion}
        type={WildcardInputQuestionTypes.Question}
        previewMode={WildcardInputPreviewModes.Survey}
      />
      <RatingDots
        minValue={isNpsSurvey ? 0 : 1}
        maxValue={isNpsSurvey ? 10 : 5}
        centeredLabel={isNpsSurvey ? undefined : '1 - Poor, 2 - Fair, 3 - Satisfactory, 4 - Good, 5 - Excellent'}
        minLabel={isNpsSurvey ? 'Not Likely' : undefined}
        maxLabel={isNpsSurvey ? 'Very Likely' : undefined}
        isInteractive={true}
        onClick={selectRating}
        selected={rating}
      />
    </Box>
  );
};

export default RatingStep;
